import { Filters, managePageFilters } from '../../../utils/urlUtil'
import { FilterValuesData } from '../filters'
import PopupInfo from '../../../components/PopupInfo/popupInfo'
import React, { useEffect, useState } from 'react'
import { Checkbox, Input } from 'semantic-ui-react'
import { MagnifyingGlass as SvgMagnifyingGlass } from 'phosphor-react'
import { useIntl } from 'react-intl'

interface IProps {
  filterPage: string
  filters: Filters
  filterOptions: string[]
  filterKey: string
  filterTitleI18NId: string
  filterOptionsData?: FilterValuesData[]
  disabledTooltip?: string
  closeFilters?: () => void
  changeFunction?: (key: string, setValue?: string) => void
}

const FilterDiscreet = (props: IProps): React.ReactElement => {
  const {
    filterPage,
    filters,
    filterOptions,
    filterOptionsData = [],
    filterKey,
    filterTitleI18NId,
    disabledTooltip = '',
    closeFilters,
    changeFunction
  } = props
  const currentFilter = filters[filterKey]

  const intl = useIntl()

  const [filterOptionValues, setFilterOptions] = useState<string[]>(filterOptions)
  const [searchClass, setSearchClass] = useState('')

  useEffect(() => setFilterOptions(filterOptions), [filterOptions])

  const handleChangeClass = (_, data) => {
    const isUnCheck = currentFilter?.includes(data.value)
    changeFunction &&
      (isUnCheck ? changeFunction(filterKey) : changeFunction(filterKey, data.value))
    managePageFilters({
      pageName: filterPage,
      filterKey, // array at the end denoted that values are ORed
      filterValues: [data.value],
      action: isUnCheck ? 'remove' : 'add'
    })
    closeFilters && closeFilters()
  }

  /**Todo: Add side effect to filter selection */

  const handleSearch = (_, { value }) => {
    setSearchClass(value)
    const valLower = value.toLowerCase()
    if (filterOptionsData.length) {
      const searchResult = filterOptionsData.filter((item) =>
        item.name.toLowerCase().includes(valLower)
      )
      return setFilterOptions(searchResult.map((item) => item.key))
    } else {
      setFilterOptions(filterOptions.filter((item) => item.toLowerCase().includes(valLower)))
    }
  }
  const searchPlaceholder = intl.formatMessage({ id: filterTitleI18NId })

  return (
    <div className="column" data-test-id="filters-filters-discreet">
      <div className="title">
        <Input
          value={searchClass}
          onChange={handleSearch}
          input={{ className: 'truncate', title: searchPlaceholder }}
          placeholder={searchPlaceholder}
          icon={
            <div className="icon-container">
              <SvgMagnifyingGlass size={20} color="var(--color-river-bed)" />
            </div>
          }
        />
      </div>
      <div className="filters-list custom-scrollbar">
        {filterOptionValues.map((item, index) => {
          const fullItem = filterOptionsData.find((name) => name.key === item)
          const text = fullItem?.name || item
          const isDisabled = !!fullItem?.isDisabled
          return (
            <div className="filter-discreet-wrapper" key={index}>
              <Checkbox
                value={item}
                checked={currentFilter !== undefined && currentFilter.includes(item)}
                disabled={isDisabled}
                label={{
                  children: (
                    <div className="truncate" title={text}>
                      {text}
                    </div>
                  )
                }}
                onChange={handleChangeClass}
                title={item}
              />
              {isDisabled && (
                <PopupInfo
                  text={disabledTooltip}
                  position="top center"
                  className="parent-filter-disabled-popup"
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default FilterDiscreet
